<template>
    <template v-if="data && selectedData">
        <div class="row">
            <select class="select_box" @change="changeItem">
                <option v-for="post of data.list" :key="post.idx" :value="post.idx">{{ post.title }}</option>
            </select>
        </div>
        <div class="table_row">
            <table class="centered_table">
                <colgroup>
                    <col width="30%" />
                    <col width="40%" />
                    <col width="30%" />
                </colgroup>
                <thead>
                    <tr>
                        <th>일자</th>
                        <th>장소</th>
                        <th>참석 주식수</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{ selectedData.meetingDate }}</td>
                        <td>{{ selectedData.location }}</td>
                        <td>{{ selectedData.attendShares }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="table_row">
            <table class="list_table" v-if="selectedDataList">
                <thead>
                    <tr>
                        <th></th>
                        <th>의안</th>
                        <th>결과</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="listItem of selectedDataList" :key="listItem.idx">
                        <td>제{{ listItem.no }}호 의안</td>
                        <td>{{ listItem.contents }}</td>
                        <td>{{ listItem.voteResult }}</td>
                    </tr>
                </tbody>
            </table>
            <LoadingWrap v-else />
        </div>
    </template>
    <LoadingWrap v-else />
</template>

<script>
import { getStockholder, getStockholdertDetail } from '@/api';
import LoadingWrap from '../LoadingWrap.vue';

export default {
    data() {
        return {
            data: [],
            selectedData: null,
            selectedDataList: null,
        };
    },
    components: {
        LoadingWrap,
    },
    async mounted() {
      try {
        const { data } = await getStockholder(this.$route.query);
        this.data = data;
        this.selectedData = this.data.list[0];
        this.selectedDataList = null;
        const {
            data: { agendaList },
        } = await getStockholdertDetail(this.data.list[0].idx);
        this.selectedDataList = agendaList;
      }catch(err){
        this.selectedData = {};
        this.selectedDataList = [1];
      }
    },
    methods: {
        async changeItem(e) {
            this.selectedDataList = null;
            this.selectedData = this.data.list.find((el) => +el.idx === +e.target.value);
            const {
                data: { agendaList },
            } = await getStockholdertDetail(e.target.value);
            this.selectedDataList = agendaList;
        },
    },
};
</script>

<style scoped lang="scss">
.row {
    margin-bottom: 30px;

    .select_box {
        width: 20%;
        height: 50px;
        max-width: 320px;
        background: #fafafa;
        padding: 0 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        appearance: none;
        border: none;
        font-size: 16px;

        background-image: url('@/assets/list_dropdown_icon.png');
        background-repeat: no-repeat;
        background-position: 95% center;

        @media screen and (max-width: 768px) {
            width: 100%;
        }

        span {
            font-size: 16px;
            color: #111;
        }

        i {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}

.table_row {
    table {
        width: 100%;
        border-top: 2px solid #333;
        border-collapse: collapse;

        th {
            background: #fafafa;
            font-weight: 700;
            font-size: 20px;
            color: #111;

            @media screen and (max-width: 768px) {
                font-size: 18px;
            }
        }

        td {
            font-size: 18px;
            color: #333;

            @media screen and (max-width: 768px) {
                font-size: 16px;
            }
        }

        tr {
            border-bottom: 1px solid #e5e5e5;
        }

        th,
        td {
            padding: 40px 0;

            @media screen and (max-width: 768px) {
                padding: 15px;
                font-size: 14px;
            }
        }

        &.centered_table {
            th,
            td {
                text-align: center;
            }
        }

        &.list_table {
            tr {
                td:first-child {
                    width: 25%;
                    text-align: center;
                    font-weight: 700;
                    color: #111;
                    font-size: 20px;

                    @media screen and (max-width: 768px) {
                        font-size: 16px;
                    }
                }

                td:last-child {
                    width: 20%;
                    text-align: center;
                }
            }
        }
    }

    & + .table_row {
        margin-top: 80px;
    }
}

@media screen and (max-width: 768px) {
    .table_row {
        overflow-x: auto;

        table {
            min-width: 520px;
        }
    }
}
</style>
